<template>
  <div class="eventos">
    <div class="container">
      <div class="row justify-content-center mb-5">
        <div class="col-md-4"></div>
      </div>
      <DialogBox ref="resultDialog"></DialogBox>
      <DialogBox ref="confirmationDialog"></DialogBox>
      <v-data-table
              :headers="headers"
              :items="eventos"
              sort-by="eventDate"
              class="elevation-1"
              locale='es'
              :footer-props="{
                'items-per-page-text': 'Filas por página'
              }"
              :loading="loading"
              loading-text="Cargando eventos..."
      >
        <template v-slot:top>
          <v-toolbar class="toolbars" flat>
            <v-toolbar-title>Eventos</v-toolbar-title>
            <v-divider
                    class="mx-4"
                    inset
                    vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn dark class="mb-2 toolbar-button" v-on="on">Crear nuevo evento</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                      <v-row justify="center">
                        <v-menu
                          v-model="datepicker"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="200px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="editedItem.eventDate"
                              label="Fecha del evento"
                              prepend-icon="fa fa-calendar"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="editedItem.eventDate" locale='es' first-day-of-week=1 @input="datepicker = false"></v-date-picker>
                        </v-menu>
                      </v-row>
                      <ul em>
                      <li>
                        <v-text-field v-model="editedItem.asunto" label="Asunto"></v-text-field>
                      </li>
                      <li>
                        <v-textarea
                                v-model="editedItem.cuerpo"
                                color="teal"
                                label="Cuerpo"
                        >
                        </v-textarea>
                      </li>
                    </ul>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                  <v-btn color="blue darken-1" text @click="saveConfirmation">Guardar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
                  large
                  class=" mr-2 fa fa-edit " aria-hidden="true"
                  @click="editItem(item)"
          >
          </v-icon>
          <v-icon
                  large
                  @click="deleteConfirmation(item)"
                  class="fa fa-trash " aria-hidden="true"
          >
          </v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>

    </div>

  </div>
</template>

<script>
/* eslint-disable no-console */
// @ is an alias to /src
import DialogBox from '../components/DialogBox'
import { DB } from '../firebase/db'
var moment = require('moment');

export default {
  name: 'eventos',
  created() {
    this.$emit('updateTitle', 'Eventos');
    this.initialize();
    window.bus.$emit('menu/activarMenu');
  },
  data: () => ({
      loading: true,
      dialog: false,
      datepicker: false,
      headers: [
        { text: 'Evento', value: 'asunto', sortable: false },
        {
          text: 'Fecha del evento',
          align: 'left',
          value: 'formattedDate',
          sortable: false
        },
        { text: 'Descripción', value: 'cuerpo', sortable: false },
        { text: '', value: 'action', sortable: false },
      ],
      eventos: [],
      editedIndex: -1,
      editedItem: {
        date: moment().format("YYYY-MM-DD"),
        eventDate: moment().format("YYYY-MM-DD"),
        asunto: '',
        cuerpo: ''
      },
      deletedItem: {
        date: moment().format("YYYY-MM-DD"),
        eventDate: moment().format("YYYY-MM-DD"),
        asunto: '',
        cuerpo: ''
      },
      defaultItem: {
        date: moment().format("YYYY-MM-DD"),
        eventDate: moment().format("YYYY-MM-DD"),
        asunto: '',
        cuerpo: ''
      },
    }),
    
    components: {
      DialogBox
    },

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo Evento' : 'Editar Evento'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    methods: {
      initialize () {

        DB.collection('eventos').onSnapshot( snapshot => {
          snapshot.docs.forEach( item => {
            let element = {
              date : item.data().date,
              eventDate : item.data().eventDate,
              formattedDate : moment(item.data().eventDate).format("DD-MM-YYYY"),
              asunto : item.data().asunto,
              cuerpo : item.data().cuerpo,
              id : item.id
            };

            let index = -1;
            for (let i = 0; i < this.eventos.length; i++) {
              if(this.eventos[i].id == item.id)
              {
                index = i;
                break;
              }
            }

            if(index == -1){
              this.eventos.push(element);
            }
            else {
              this.eventos[index].id = element.id;
              this.eventos[index].date = element.date;
              this.eventos[index].eventDate = element.eventDate;
              this.eventos[index].formattedDate = moment(element.eventDate).format("DD-MM-YYYY");
              this.eventos[index].asunto = element.asunto;
              this.eventos[index].cuerpo = element.cuerpo;
            }

            this.loading = false;
          })
        })
      },

      editItem (element) {

        this.editedIndex = this.eventos.indexOf(element)
        this.editedItem = Object.assign({}, element)
        this.dialog = true
        
      },

      deleteConfirmation(element) {
        this.deletedItem = element;
        this.$refs.confirmationDialog.show('warning', 
        `¿Está seguro que desea eliminar el evento con asunto '${this.deletedItem.asunto}'?`,
        true,
        this.deleteItem)
      },

      deleteSuccess() {
        this.$refs.resultDialog.show('info', 'Aviso eliminado con éxito.', false);
      },

      deleteItem () {
        return new Promise((resolve, reject) => {
          const index = this.eventos.indexOf(this.deletedItem);
          DB.collection('eventos').doc(this.deletedItem.id).delete().then( () => {
            this.eventos.splice(index, 1);
            this.deleteSuccess();
            resolve();
          })
          .catch( error => {
            console.error(error);
            this.errorDialog("Se ha producido un error al eliminar un elemento en la base de datos.");
            reject(error)
          })
        })
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      saveConfirmation() {
        this.$refs.confirmationDialog.show('question', 
        `¿Está seguro que desea guardar el evento con asunto ${this.editedItem.asunto}?`,
        true,
        this.save)
      },

      saveSuccess() {
        this.$refs.resultDialog.show('info', 'Evento guardado con éxito.', false);
      },
      
      errorDialog(error) {
        this.$refs.resultDialog.show('error', error + " Compruebe la conexión a Internet. Si el problema persiste contacte con el administrador.", false);
      },

      save () {

        let item = {
            date : this.editedItem.date,
            eventDate: this.editedItem.eventDate,
            asunto : this.editedItem.asunto,
            cuerpo : this.editedItem.cuerpo,
        };

        return new Promise((resolve, reject) => {
          if (this.editedIndex > -1) {
          
            DB.collection('eventos').doc(this.editedItem.id).set(item)
            .then(() => {
              this.saveSuccess();
              resolve();
            })
            .catch( error => {
              console.error(error);
              this.errorDialog("Se ha producido un error al guardar un elemento en la base de datos.");
              reject(error);
            })
          } else {
            DB.collection('eventos').doc().set(item)
            .then(() => {
              this.saveSuccess();
              resolve();
            })
            .catch( error => {
              console.error(error);
              this.errorDialog("Se ha producido un error al guardar un elemento en la base de datos.");
              reject(error);
            }) 
          }
          this.close()
        })
      },
    },
}
</script>